import { render, staticRenderFns } from "./ProductPieCard.vue?vue&type=template&id=35feafa3"
import script from "./ProductPieCard.vue?vue&type=script&lang=js"
export * from "./ProductPieCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports